import QuoteDetails from './QuoteDetails'

export default QuoteDetails
